jQuery(document).ready(function ($) {
  // If error/notice on checkout submit, scroll to top.

  // browser window scroll (in pixels) after which the "back to top" link is shown
  var offset = 300,
    //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
    offset_opacity = 1200,
    //duration of the top scrolling animation (in ms)
    scroll_top_duration = 700,
    //grab the "back to top" link
    $checkout_button = $(".checkout-button.button");
  $place_order = $("#place_order");

  //smooth scroll to top
  $checkout_button.on("click", function (event) {
    if ($(".woocommerce-error")) {
      $("body,html").animate(
        {
          scrollTop: 0,
        },
        scroll_top_duration
      );
    }
  });

 $(document.body).on("checkout_error", function () {
    $("html, body").stop();
    $("body,html").animate(
      {
        scrollTop: 0,
      },
      scroll_top_duration
    );
  });
});
